module.exports = __webpack_public_path__ + "static/telia-863774a6c6bc7a867aa3078932114a58.svg";